export function reportWarning(message: string): void {
  console.warn(message)
}
